import { axiosInstance as axios } from '../lib/axios'
import { IPIRANGA_PROMOTION_AVAILABLE, IPIRANGA_PROMOTION_RESET } from '../actionTypes/ipirangaPromotion'
import { isIpirangaPromotionMockEnabled } from '../views/IpirangaPromotionListPage/hooks/ipirangaPromotionMock'

// REV-1872: POST /national-promotion/available responde se ALGUM dos postos
// participa de promoção Ipiranga ativa ({ success: boolean }). Controla a
// exibição do item "Promoção Ipiranga" nos menus. Falha de rede = oculto.
// REV-1986: usado quando o backoffice volta ao busca-parceiro — invalida a
// resposta do posto anterior para o boot gate re-segurar na próxima seleção
export const resetIpirangaPromotionAvailable = () => ({ type: IPIRANGA_PROMOTION_RESET })

export const getIpirangaPromotionAvailable = (storeIds) => async (dispatch) => {
  const dispatchAvailable = (available) =>
    dispatch({ type: IPIRANGA_PROMOTION_AVAILABLE, payload: available })

  if (isIpirangaPromotionMockEnabled()) {
    dispatchAvailable(true)
    return
  }

  if (!Array.isArray(storeIds) || storeIds.length === 0) {
    dispatchAvailable(false)
    return
  }

  try {
    const { data } = await axios.post('/national-promotion/available', { store_ids: storeIds })
    dispatchAvailable(data?.success === true)
  } catch (error) {
    dispatchAvailable(false)
  }
}
